// ── Early Bird 周报草稿生成 — 纯文本组装逻辑 ──────────────────────────
// 选品（fetchWeeklyDigestCandidates）和文案组装分开：这个文件只管"选中的
// 项目列表 → 一段可复制发布的文案"，不碰网络请求，方便单测。
// 信号标签用真实存在的字段（site_alive / github_pushed_at 算出的活跃度），
// 不编 Early Bird 项目池里没有算过的"双源零融资"（那是 RootData 热榜的概念）。

export const SIGNAL_LABELS = {
  site_alive: { zh: '网站可访问', en: 'Site reachable' },
  github_active: { zh: 'GitHub 活跃', en: 'Active on GitHub' },
};

export function projectShareUrl(origin, id) {
  return `${origin}/earlybird/${encodeURIComponent(id)}`;
}

function signalLabel(project, lang) {
  const meta = SIGNAL_LABELS[project.signal];
  return meta ? (lang === 'en' ? meta.en : meta.zh) : null;
}

/**
 * Twitter/X 长文草稿：编号列表 + 每条项目的分享链接 + 结尾话题标签。
 * @param {Array<object>} projects - 已勾选纳入草稿的项目（含 signal 字段）
 * @param {object} opts
 * @param {string} opts.origin - 当前站点 origin，用于拼分享链接
 * @param {string} [opts.weekLabel] - 周期文案，如 "2026-07-01 ~ 07-07"
 * @param {'zh'|'en'} [opts.lang]
 */
export function buildTwitterDraft(projects, { origin, weekLabel = '', lang = 'zh' }) {
  const en = lang === 'en';
  const lines = [];
  lines.push(en ? `This week's Early Bird radar${weekLabel ? ` · ${weekLabel}` : ''}` : `本周 Early Bird 雷达${weekLabel ? ` · ${weekLabel}` : ''}`);
  lines.push(en
    ? `${projects.length} projects with rising heat, ahead of capital`
    : `热度已起、资本尚未入场的 ${projects.length} 个项目`);
  lines.push('');
  projects.forEach((p, i) => {
    const sig = signalLabel(p, lang);
    lines.push(`${i + 1}/ ${p.project_name}${p.tax_category ? ` · ${p.tax_category}` : ''}`);
    if (p.one_liner || p.description) lines.push(p.one_liner || p.description);
    lines.push(`${sig ? `${sig} · ` : ''}via ${p.organization}`);
    lines.push(projectShareUrl(origin, p.id));
    lines.push('');
  });
  lines.push(en ? `Full list on PrimaryLens Early Bird · ${origin}` : `完整榜单看 PrimaryLens Early Bird · ${origin}`);
  lines.push('#Web3 #EarlyBird #PrimaryLens');
  return lines.join('\n').trim();
}

/**
 * Markdown 草稿：无序列表，每条带项目名/赛道/来源/简介/信号标签/链接。
 */
export function buildMarkdownDraft(projects, { origin, weekLabel = '', lang = 'zh' }) {
  const en = lang === 'en';
  const lines = [];
  lines.push(en ? `# Early Bird weekly digest${weekLabel ? ` · ${weekLabel}` : ''}` : `# Early Bird 周报${weekLabel ? ` · ${weekLabel}` : ''}`);
  lines.push('');
  projects.forEach((p) => {
    const sig = signalLabel(p, lang);
    const parts = [p.tax_category, p.organization].filter(Boolean).join(' · ');
    const desc = p.one_liner || p.description || '';
    lines.push(`- **${p.project_name}**${parts ? `（${parts}）` : ''}${desc ? ` — ${desc}` : ''}${sig ? ` \`${sig}\`` : ''}`);
    lines.push(`  ${projectShareUrl(origin, p.id)}`);
  });
  return lines.join('\n').trim();
}
